import styled from '@emotion/styled'
import { Box, BoxProps } from '@chakra-ui/react'

const Column = styled(Box)<BoxProps>({ display: 'flex', flexDirection: 'column' })

Column.displayName = 'Column'

export default Column
